// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LoggedIn-homepage-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 52px);
  background-color: var(--background);
  color: var(--theme-consistent);
}

.LoggedIn-logo-container {
  position: relative;
  margin-bottom: 30px;
}

.LoggedIn-flickswipe-logo {
  width: 100%;
  opacity: 0;
  animation: fadeInScale 2s forwards;
}

.LoggedIn-tagline-container {
  position: relative;
  top: -100px;
  left: 0;
  font-size: 1rem;
  text-align: center;
  opacity: 0;
  animation: fadeIn 2s forwards;
  animation-delay: 1s;
}

.LoggedIn-tagline {
  position: relative;
  top: -20px;
}

.home-premium {
  margin: 0 1rem 5rem 1rem;
}

.home-free-btn {
  background: linear-gradient(135deg, #ff5e5e, #ff9966);
  color: white;
  border-radius: 30px;
  padding: 10px 20px;
  box-shadow: rgba(40, 40, 40, 0.35) 0px 5px 15px;
  border: none;
  cursor: pointer;
  font-size: 1.5em;
  font-weight: bold;
  transition: all 0.3s ease;
  text-align: center;
  margin: 4px;
  text-decoration: none;
}

.home-free-btn a {
  text-decoration: none;
  color: white;
}

@keyframes fadeIn {
  0% { opacity: 0; }
  100% { opacity: 1; }
}

@keyframes fadeInScale {
  0% { opacity: 0; transform: scale(0.5); }
  100% { opacity: 1; transform: scale(1); }
}

.premium-features {
  margin-top: 2rem;
}

/* Adjust the height of the video on smaller screens */
@media screen and (max-width: 375px) {
  .LoggedIn-tagline-container {
    top: -125px;
  }
  .LoggedIn-tagline {
    font-size: 1.25rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/LoggedInHomepage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,+CAA+C;EAC/C,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,KAAK,UAAU,EAAE;EACjB,OAAO,UAAU,EAAE;AACrB;;AAEA;EACE,KAAK,UAAU,EAAE,qBAAqB,EAAE;EACxC,OAAO,UAAU,EAAE,mBAAmB,EAAE;AAC1C;;AAEA;EACE,gBAAgB;AAClB;;AAEA,sDAAsD;AACtD;EACE;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".LoggedIn-homepage-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: calc(100vh - 52px);\n  background-color: var(--background);\n  color: var(--theme-consistent);\n}\n\n.LoggedIn-logo-container {\n  position: relative;\n  margin-bottom: 30px;\n}\n\n.LoggedIn-flickswipe-logo {\n  width: 100%;\n  opacity: 0;\n  animation: fadeInScale 2s forwards;\n}\n\n.LoggedIn-tagline-container {\n  position: relative;\n  top: -100px;\n  left: 0;\n  font-size: 1rem;\n  text-align: center;\n  opacity: 0;\n  animation: fadeIn 2s forwards;\n  animation-delay: 1s;\n}\n\n.LoggedIn-tagline {\n  position: relative;\n  top: -20px;\n}\n\n.home-premium {\n  margin: 0 1rem 5rem 1rem;\n}\n\n.home-free-btn {\n  background: linear-gradient(135deg, #ff5e5e, #ff9966);\n  color: white;\n  border-radius: 30px;\n  padding: 10px 20px;\n  box-shadow: rgba(40, 40, 40, 0.35) 0px 5px 15px;\n  border: none;\n  cursor: pointer;\n  font-size: 1.5em;\n  font-weight: bold;\n  transition: all 0.3s ease;\n  text-align: center;\n  margin: 4px;\n  text-decoration: none;\n}\n\n.home-free-btn a {\n  text-decoration: none;\n  color: white;\n}\n\n@keyframes fadeIn {\n  0% { opacity: 0; }\n  100% { opacity: 1; }\n}\n\n@keyframes fadeInScale {\n  0% { opacity: 0; transform: scale(0.5); }\n  100% { opacity: 1; transform: scale(1); }\n}\n\n.premium-features {\n  margin-top: 2rem;\n}\n\n/* Adjust the height of the video on smaller screens */\n@media screen and (max-width: 375px) {\n  .LoggedIn-tagline-container {\n    top: -125px;\n  }\n  .LoggedIn-tagline {\n    font-size: 1.25rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
